import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'
import { Text } from '@mxenabled/mxui'

import { useFinstrongStore, useGlobalCopyStore } from '../../../common'
import { getPercentFromRatio, getSpendToIncomeRatioState } from '../../util/finstrongUtils'

import ProgressBar from '../ProgressBar'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

const SpendLessThanYouMakeProgressBar = () => {
  const { healthScore } = useFinstrongStore()
  const { finstrong: copy } = useGlobalCopyStore()

  const spend = getPercentFromRatio(healthScore.spend_to_income_ratio)
  const spendPercentage = spend ?? 0

  // Check if healthScore is empty
  const isHealthScoreEmpty = Object.keys(healthScore).length === 0

  const cardStatus = getSpendToIncomeRatioState(spend)

  const statusBarData = {
    GOOD: [{ percentage: `${spendPercentage}%` }],
    FAIR: [{ percentage: '100%' }, { percentage: `${spendPercentage - 100}%` }],
    OFF_TRACK: [{ percentage: '100%' }, { percentage: `${spendPercentage - 100}%` }],
    MISSING: [{ percentage: '0%' }],
  }[cardStatus]

  return (
    <ProgressBar
      bottomComponent={
        <Stack
          sx={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 8,
          }}
        >
          <Text variant="body2">
            {healthScore.ninety_day_income <= 0
              ? '-'
              : formatCurrency(healthScore.ninety_day_income, '0,0.00')}
            &nbsp;
            {copy?.key_indicators_spend.spend_less_than_you_make_drawer.income}
          </Text>
          <Text variant="body2">
            {spendPercentage <= 0 ? '-%' : `${spendPercentage}%`}&nbsp;
            {copy?.key_indicators_spend.spend_less_than_you_make_drawer.spent}
          </Text>
        </Stack>
      }
      label={
        copy?.key_indicators_spend.spend_less_than_you_make_drawer
          .spend_less_than_you_make_sticky_description
      }
      status={cardStatus}
      statusBarData={statusBarData}
      value={isHealthScoreEmpty ? '$0' : formatCurrency(healthScore.ninety_day_spend, '0,0.00')}
    />
  )
}

export default observer(SpendLessThanYouMakeProgressBar)
